import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Settings } from '../settings';

@Injectable()

export class PlaylistService {

  private contentHeadersJson: HttpHeaders;
  private baseUrl: string;

  constructor(
    private http: HttpClient
  ) {
    this.baseUrl = Settings.baseUrlBackend;
    this.ini();
  }

  // Métodos generales
  public ini(): void {
  }

  getPlaylist(playlistGUID: string): Observable<any> {
    const url = this.baseUrl + '/rest/core/servicios/obtenerVideosDePlaylist';
    const localStorageToken = localStorage.getItem('APPTenfieldPlayerAccessToken');
    const token = localStorageToken && localStorageToken.trim().length > 0 ? localStorageToken.trim() : '';
    const body = {
      Token : token,
      PlayListGUID: playlistGUID
    };
    const options = { headers: this.contentHeadersJson };

    const request: Observable<any> = this.http.post(url, body, options);
    return request;
  }
}
